module.exports = __webpack_public_path__ + "img/bondholder.13b210a7.svg";